if (!customElements.get('smooth-collection')) {
  customElements.define('smooth-collection', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.smooth-collection__viewport');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = Number(this.dataset.speed) || 15;
      this.designMode = !!window.Shopify?.designMode;
      this.autoplay = this.dataset.autoplay === 'true';
      this.running = this.autoplay && !this.motion.matches && !this.designMode;
      this.visible = false;
      this.lastTime = null;
      this.position = null;
      this.pause = this.pause.bind(this);
      this.tick = this.tick.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);
      this.rebuild = this.rebuild.bind(this);
      this.onMouseDown = this.onMouseDown.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseUp = this.onMouseUp.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.viewport.addEventListener('pointerdown', this.pause, { passive: true });
      this.viewport.addEventListener('mousedown', this.onMouseDown);
      this.viewport.addEventListener('click', this.onClick, true);
      this.viewport.addEventListener('dragstart', this.onDragStart);
      this.viewport.addEventListener('wheel', this.pause, { passive: true });
      this.viewport.addEventListener('focusin', this.pause);
      this.motion.addEventListener('change', this.onMotionChange);
      this.resizeObserver = new ResizeObserver(this.rebuild);
      this.resizeObserver.observe(this.viewport);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.lastTime = null;
      });
      this.observer.observe(this);
      this.rebuild();
      this.frame = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer.disconnect();
      this.resizeObserver.disconnect();
      this.viewport.removeEventListener('pointerdown', this.pause);
      this.viewport.removeEventListener('mousedown', this.onMouseDown);
      this.viewport.removeEventListener('click', this.onClick, true);
      this.viewport.removeEventListener('dragstart', this.onDragStart);
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
      clearTimeout(this.clickResetTimer);
      this.viewport.removeEventListener('wheel', this.pause);
      this.viewport.removeEventListener('focusin', this.pause);
      this.motion.removeEventListener('change', this.onMotionChange);
    }

    rebuild() {
      this.position = null;
      this.lastTime = null;
    }

    pause() {
      if (!this.running) return;
      this.running = false;
      this.lastTime = null;
      this.position = null;
    }

    onMouseDown(event) {
      if (event.button !== 0 || event.target === this.viewport || this.viewport.scrollWidth <= this.viewport.clientWidth) return;
      this.mouseStart = event.clientX;
      this.scrollStart = this.viewport.scrollLeft;
      this.dragged = false;
      clearTimeout(this.clickResetTimer);
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseup', this.onMouseUp);
    }

    onMouseMove(event) {
      const distance = event.clientX - this.mouseStart;
      if (!this.dragged && Math.abs(distance) < 5) return;
      this.dragged = true;
      this.viewport.classList.add('is-dragging');
      this.viewport.scrollLeft = this.scrollStart - distance;
      event.preventDefault();
    }

    onMouseUp() {
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
      this.viewport.classList.remove('is-dragging');
      this.clickResetTimer = setTimeout(() => { this.dragged = false; }, 0);
    }

    onClick(event) {
      if (!this.dragged) return;
      event.preventDefault();
      event.stopPropagation();
      this.dragged = false;
    }

    onDragStart(event) {
      event.preventDefault();
    }

    onMotionChange() {
      if (this.motion.matches) this.pause();
      this.rebuild();
    }

    tick(time) {
      if (this.running && this.visible && !document.hidden) {
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        if (maxScroll > 1 && this.lastTime !== null) {
          if (this.position === null) this.position = this.viewport.scrollLeft;
          const next = this.position + this.speed * Math.min(time - this.lastTime, 50) / 1000;
          this.position = Math.min(next, maxScroll);
          this.viewport.scrollLeft = this.position;
          if (this.position >= maxScroll) this.pause();
        }
        this.lastTime = time;
      } else {
        this.lastTime = null;
      }
      this.frame = requestAnimationFrame(this.tick);
    }
  });
}
